import { Dispatch, SetStateAction, useState } from 'react'

import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { ReactComponent as Close } from '../../../../assets/icons/close.svg'
import { useResponsesStore } from '../../../../stores/responsesStore'

import { joinClassNames } from '../../../../utils/styles'
import styles from './edit-response-nav-item.module.scss'

interface IEditResponseNavItem {
    isActive: boolean
    response: string
    setIsResponseEditing: Dispatch<SetStateAction<boolean>>
}

function EditResponseNavItem(props: IEditResponseNavItem) {
    const { isActive, response, setIsResponseEditing } = props

    const [, { editResponseName }] = useResponsesStore()

    const [newResponseName, setNewResponseName] = useState(response)

    const handleSubmitEditing = () => {
        editResponseName(response, newResponseName)
        setIsResponseEditing(true)
    }

    const handleCancelEditing = () => {
        setNewResponseName(response)
        setIsResponseEditing(false)
    }

    return (
        <>
            <input
                value={newResponseName}
                onChange={(e) => setNewResponseName(e.target.value)}
                className={joinClassNames(
                    styles.editResponseNavItem__input,
                    isActive && styles.editResponseNavItem__inputActive
                )}
            />
            <div className={styles.editResponseNavItem__buttons}>
                <button
                    onClick={handleSubmitEditing}
                    className={styles.editResponseNavItem__btn}
                >
                    <CheckmarkCircle />
                </button>
                <button
                    onClick={handleCancelEditing}
                    className={styles.editResponseNavItem__btn}
                >
                    <Close />
                </button>
            </div>
        </>
    )
}

export default EditResponseNavItem
